import { type MarkdownDataMap } from '@atlassian/conversation-assistant-content-transformer/utils/stream-markdown-parser';
import { type StreamAnswerPart } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { addAnswerPart as serviceAddAnswerPart } from '@atlassian/conversation-assistant-service/services/assistance-service/utils/data';
import {
	type StoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { updateStoreAssistant } from './updateStoreAssistant';

export const addAnswerPartWithMarkdownDataMap = ({
	chat,
	answerId,
	answerPart,
	markdownData,
	extraMarkdownData,
	useIndex,
}: {
	chat: StoreChatItem[];
	answerId: string;
	answerPart: StreamAnswerPart;
	markdownData: MarkdownDataMap;
	/** Set as is after `markdownData` is appended, for keys that must not accumulate. */
	extraMarkdownData?: Record<string, string>;
	useIndex?: number;
}): StoreChatItem[] => {
	return updateStoreAssistant({
		chat,
		promptId: answerId,
		updateFunction: (storeAssistant): StoreAssistant => {
			const updatedMarkdownData = Object.entries(markdownData).reduce(
				(acc, [key, { content, loading }]) => {
					const loadingKey = `${key}-loading`;
					return {
						...acc,
						[key]: (acc[key] || '') + content,
						[loadingKey]: loading ? 'true' : 'false',
					};
				},
				{ ...storeAssistant.markdownData },
			);

			return {
				...storeAssistant,
				content: {
					...serviceAddAnswerPart(storeAssistant.content, answerPart),
					streamingComplete: false,
				},
				markdownData: extraMarkdownData
					? { ...updatedMarkdownData, ...extraMarkdownData }
					: updatedMarkdownData,
			};
		},
		updateType: 'Add Answer Part With Markdown Data',
		useIndex,
	});
};
